<template>
  <v-container fluid>
    <v-row justify="start">
      <v-col cols="12" md="10" class="pt-0">
        <p class="text-h6 fontGrey--text text-right">לשליחת סים בדואר יש למלא את הפרטים הבאים</p>
        <p class="text-body-2 secondary--text text-right">
          כרוך בתשלום של 25 ש״ח (כולל משלוח)
        </p>
        <!-- name -->
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            :label="'הכנס פרטי לקוח'"
            outlined
            :rules="nameRules"
            required
            v-model="userName"
          >
          </v-text-field>
        </v-col>
        <!--  address -->
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            :label="'הכנס כתובת למשלוח'"
            outlined
            :rules="[(v) => !!v || 'Item is required']"
            required
            v-model="userAddress"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
              <v-text-field
                :label="'הכנס אימייל לעידכון סטטוס '"
                outlined
                required
                :rules="emailRules"
                v-model="userEmail"
              >
                <!-- :value="userEmail" -->
              </v-text-field>
            </v-col>
            <v-col class="px-0">
                    <PlainButton
                      :buttonText="'לחץ להמשך הזמנה'"
                      :method="'sendToSupport'"
                      :textConfigs="{
                        label: 'text-h5 mb-1 fontGrey--text font-weight-bold',
                      }"
                      @sendToSupport="sendOrderToSupport"
                    />
                  </v-col>
        <!-- </CommonPanel> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import inputRules from "@/mixins/inputRules";
import PlainButton from "@/components/CommonComponents/Buttons/PlainButton";
import { mapGetters } from "vuex";

export default {
  name: "NewSimOrder",
  mixins: [inputRules],
  components: {
    PlainButton,
  },
  data() {
    return {
        clientName: null,
      clientAddress: null,
      clientEmail: null,

    };
  },
  computed: {
    ...mapGetters(["getUserProfile"]),
    user() {
      return this.getUserProfile;
    },
    //mixin
    userName: {
      get() {
        // console.log('get userName', this.user);
        return this.user.profile.name;
      },
      set(val) {
        // console.log("val ", val);
        this.clientName = val;
      },
    },
    userAddress: {
      get() {
        return this.user.profile.address;
      },
      set(val) {
        // console.log("val ", val);
        this.clientAddress = val;
      },
    },
    userEmail: {
     
      get() {
        // console.log('get userName', this.user);
        return this.user.profile.email;
      },
      set(val) {
        // console.log("val ", val);
        this.clientEmail = val;
      },
    },
  },
  methods: {
    sendOrderToSupport() {
        console.log('send this order');
    }
  }
};
</script>
